var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isAuthenticated)?_c('div',{staticClass:"floating-button--container"},[_c('transition',{attrs:{"name":"slow"}},[(_vm.showChatBox)?_c('div',{staticClass:"chat-window"},[_c(_vm.chatWindow,{tag:"component"})],1):_vm._e()])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }